/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Tournament_Rules_TitleInputs */



/**
* | output |
* | --- |
* | "Tournament Rules" |
*
* @param {Help_Tournament_Rules_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const help_tournament_rules_title = /** @type {((inputs?: Help_Tournament_Rules_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Tournament_Rules_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Règles de tournoi")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reglas de torneo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Regras de torneio")
	if (locale === "it") return /** @type {LocalizedString} */ ("Regole dei tornei")
	return /** @type {LocalizedString} */ ("Tournament Rules")
});